<script setup lang="ts">
import type { Decorator } from "@/types"
import StatusDecoration from "@/components/FileImport/StatusDecoration.vue"

interface Props {
  /**
   * Step Title
   */
  title: string

  /**
   * Step Decorator
   */
  decorator: Decorator

  /**
   * Is currently active boolean
   */
  isCurrent: boolean
}

defineProps<Props>()
</script>

<template>
  <div class="relative my-1 flex flex-col items-center rounded-lg p-1 hover:bg-gray-200">
    <div
      class="flex items-center gap-x-1 text-sm"
      :class="{ 'font-bold': isCurrent }"
    >
      <span>{{ title }}</span>
      <StatusDecoration :decorator="decorator" />
    </div>

    <span
      class="absolute inset-x-0 -bottom-1 flex h-1 w-full rounded-full"
      :class="{
        'bg-violet-500': isCurrent,
        'bg-transparent': !isCurrent,
      }"
    />
  </div>
</template>
